<div id="unsubscribe-container" class="container">
  <mat-card appearance="outlined">
    
    <mat-card-title *ngIf="unsubscribe_model.active_opt_out === true">You are now <i><b>unsubscribed</b></i> from {{ unsubscribe_model.notification_category }} Emails</mat-card-title>
    <mat-card-title *ngIf="unsubscribe_model.active_opt_out === false">You are now <i><b>subscribed</b></i> to {{ unsubscribe_model.notification_category }} Emails</mat-card-title>

    <mat-card-content *ngIf="unsubscribe_model.active_opt_out === true">
      <p>Sorry to see you go, but you can always subscribe again later.</p>
      <a href="" (click)="resubscribe($event)">
            <p>Resubscribe to {{ unsubscribe_model.notification_category }} emails</p>
      </a>
    </mat-card-content>

    <mat-card-content *ngIf="unsubscribe_model.active_opt_out === false">
      <p>Thanks for your preference update!</p>
      <a href="" (click)="unsubscribe($event)">
            <p>Unsubscribe to {{ unsubscribe_model.notification_category }} emails</p>
      </a>
    </mat-card-content>
  </mat-card>
</div>